import { render, staticRenderFns } from "./EditOnvifDiscoveryVersion.vue?vue&type=template&id=6f2c39bb"
import script from "./EditOnvifDiscoveryVersion.vue?vue&type=script&lang=js"
export * from "./EditOnvifDiscoveryVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports